import { useChannelStateContext, useMessageContext } from 'stream-chat-react';
import { UnknownType, UserResponse } from 'stream-chat';

import CustomMessage from '../CustomMessage';
import CardMessage from '../CardMessage';
import { ChannelStatus } from '../../../hooks/useChannelStatus';
import MissedCallMessageWrapper from '../MissedCallMessageWrapper';
import { ExtendedGetStreamMessage } from '../UIMessage/types';
import { isMissedCall } from '../MissedCallMessageWrapper/types';
import useVideoEnable from '../../../../../hooks/useVideoEnable';
import { useMessages } from '../../../contexts/MessagesContext';

interface WrapperMessageProps {
    channelStatus: number;
    startMeetingIndex: number;
    guestUser: UserResponse<UnknownType>;
}

const MessageWrapper: React.FC<WrapperMessageProps> = ({
    channelStatus,
    startMeetingIndex,
    guestUser,
}) => {
    const { eventUniqueName } = useMessages();
    const { data: shouldDisplay } = useVideoEnable(eventUniqueName);

    const { messages } = useChannelStateContext();
    const { message } = useMessageContext();
    const messageType = (message as ExtendedGetStreamMessage).metadata?.type;

    if (isMissedCall(messageType)) {
        return <MissedCallMessageWrapper />;
    }

    if (!shouldDisplay) {
        return <CustomMessage />;
    }

    const onlyHostSendMessage =
        channelStatus === ChannelStatus.HostSend && messages[messages.length - 1].id === message.id;
    const onlyGuestSendMessage =
        channelStatus === ChannelStatus.GuestSend &&
        messages[messages.length - 1].id === message.id;
    const hostAndGuestSendMessages =
        channelStatus === ChannelStatus.StartMeeting &&
        messages[startMeetingIndex].id === message.id;

    if (onlyHostSendMessage) {
        return (
            <>
                <CustomMessage />
                <CardMessage
                    emoji={'☕️'}
                    text={`Good start! Once ${guestUser.firstName} replies, you’ll both have the option to call and meet each other`}
                />
            </>
        );
    }

    if (onlyGuestSendMessage) {
        return (
            <>
                <CustomMessage />
                <CardMessage
                    emoji={'😍'}
                    text={`After you reply to ${guestUser.firstName} you’ll have the option to call and meet each other`}
                />
            </>
        );
    }

    if (hostAndGuestSendMessages) {
        return (
            <>
                <CustomMessage />
                <CardMessage
                    emoji={'📣'}
                    text={
                        'You can now message and meet each other! <br /> Check out the “Meet button” above'
                    }
                />
            </>
        );
    }

    return <CustomMessage />;
};

export default MessageWrapper;
